import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import colors from '../../styles/colors';
import CardTitle from './CardTitle';
import CardDescription from './CardDescription';
import variants from './variants';

const cardVariant = ({ variant }) => {
  let backgroundColor;
  let color;

  switch (variant) {
    case variants.PRIMARY:
      backgroundColor = colors.base.alpha;
      color = colors.base.beta;
      break;
    case variants.SECONDARY:
      backgroundColor = colors.base.secondary2;
      color = colors.base.alpha;
      break;
    case variants.DARK:
      backgroundColor = colors.base.beta;
      color = colors.base.primary;
      break;
    case variants.DANGER:
      backgroundColor = colors.base.danger;
      color = colors.base.alpha;
      break;
    default:
      backgroundColor = colors.base.alpha;
      color = colors.base.beta;
  }

  return css`
    background-color: ${backgroundColor};
    color: ${color};
  `;
};

const textColor = ({ variant }) => {
  let color;

  switch (variant) {
    case variants.PRIMARY:
      color = colors.base.beta;
      break;
    case variants.SECONDARY:
      color = colors.base.alpha;
      break;
    case variants.DARK:
      color = colors.base.primary;
      break;
    case variants.DANGER:
      color = colors.base.alpha;
      break;
    default:
      color = colors.base.beta;
  }

  return css`color: ${color};`;
};

const Card = styled.div`
  padding: 16px;
  transition: all 0.4s linear;
  overflow: hidden;
  box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.1);
  ${(props) => cardVariant(props)}
  ${(props) => props.onClick && 'cursor: pointer;'}

  ${CardTitle},
  ${CardDescription} {
    ${(props) => textColor(props)}
  }
`;

Card.propTypes = {
  variant: PropTypes.oneOf(Object.values(variants)),
};

Card.defaultProps = {
  variant: variants.PRIMARY,
};

export default Card;
